import { lazy } from "react";
import url from "src/config/search.json";

const UploadDataPage = lazy(() => import("src/pages/map-display/upload-data"));
const LayerFromUrlPage = lazy(
  () => import("src/pages/map-display/layer-from-url")
);
const LocallyStoredPage = lazy(
  () => import("src/pages/map-display/locally-stored")
);
const keys = Object.keys(url.services);
const currentkey = keys[0];

export const mapDisplayRoutes = [
  {
    path: currentkey,

    children: [
      {
        path: url.services.Import_Your_Data[0].url,
        element: <UploadDataPage />,
      },
      {
        path: url.services.Import_Your_Data[1].url,
        element: <LayerFromUrlPage />,
      },
      {
        path: url.services.Import_Your_Data[2].url,
        element: <LocallyStoredPage />,
      },
    ],
  },
];
